require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fab = undefined;
var _jsxFileName = 'src/basic/Fab.js';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactNative = require("react-native-web/dist/index");

var _lodash = require('lodash');

var _nativeBaseShoutemTheme = require('native-base-shoutem-theme');

var _platform = require("../theme/variables/platform");

var _platform2 = _interopRequireDefault(_platform);

var _commonColor = require("../theme/variables/commonColor");

var _computeProps = require("../utils/computeProps");

var _computeProps2 = _interopRequireDefault(_computeProps);

var _mapPropsToStyleNames = require("../utils/mapPropsToStyleNames");

var _mapPropsToStyleNames2 = _interopRequireDefault(_mapPropsToStyleNames);

var _Button = require("./Button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DIRECTION = {
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
  UP: 'up'
};
var POSITION = {
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight'
};

var AnimatedFab = _reactNative.Animated.createAnimatedComponent(_Button.Button);

var Fab = function (_Component) {
  _inherits(Fab, _Component);

  function Fab(props) {
    _classCallCheck(this, Fab);

    var _this = _possibleConstructorReturn(this, (Fab.__proto__ || Object.getPrototypeOf(Fab)).call(this, props));

    _this.prepareButtonProps = function (child) {
      var inp = (0, _lodash.clone)(child.props);
      delete inp.style;
      var defaultProps = {};
      return (0, _computeProps2["default"])(inp, defaultProps);
    };

    _this.fabTopValue = function (pos) {
      if (pos === POSITION.TOP_LEFT) {
        return {
          top: _platform2["default"].fabDefaultPosition,
          bottom: undefined,
          left: _platform2["default"].fabDefaultPosition,
          right: undefined
        };
      } else if (pos === POSITION.BOTTOM_RIGHT) {
        return {
          top: undefined,
          bottom: _platform2["default"].fabDefaultPosition,
          left: undefined,
          right: _platform2["default"].fabDefaultPosition
        };
      } else if (pos === POSITION.BOTTOM_LEFT) {
        return {
          top: undefined,
          bottom: _platform2["default"].fabDefaultPosition,
          left: _platform2["default"].fabDefaultPosition,
          right: undefined
        };
      } else if (pos === POSITION.TOP_RIGHT) {
        return {
          top: _platform2["default"].fabDefaultPosition,
          bottom: undefined,
          left: undefined,
          right: _platform2["default"].fabDefaultPosition
        };
      }

      return null;
    };

    _this.containerHeight = new _reactNative.Animated.Value(_platform2["default"].fabWidth);
    _this.containerWidth = new _reactNative.Animated.Value(0);
    _this.buttonScale = new _reactNative.Animated.Value(0);
    _this.state = {
      buttons: undefined,
      active: false
    };
    return _this;
  }

  _createClass(Fab, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var childrenArray = _react2["default"].Children.toArray(this.props.children);

      var icon = (0, _lodash.remove)(childrenArray, function (item) {
        if (item.type.displayName === 'Styled(Button)') {
          return true;
        }

        return null;
      });
      this.setState({
        buttons: icon.length
      });
      this.activeTimer = setTimeout(function () {
        _this2.setState({
          active: _this2.props.active
        });
      }, 0);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.activeTimer) {
        clearTimeout(this.activeTimer);
      }
    }
  }, {
    key: 'getOtherButtonStyle',
    value: function getOtherButtonStyle(child, i) {
      var _props = this.props,
          active = _props.active,
          direction = _props.direction;
      var type = {
        top: direction ? this.fabOtherBtns(direction, i).top : undefined,
        left: direction ? this.fabOtherBtns(direction, i).left : 8,
        right: direction ? this.fabOtherBtns(direction, i).right : 0,
        bottom: direction ? this.fabOtherBtns(direction, i).bottom : active === false ? _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? 8 : 8 : i * 50 + 50
      };
      return (0, _lodash.merge)(this.getInitialStyle().buttonStyle, _reactNative.StyleSheet.flatten(child.props.style), type);
    }
  }, {
    key: 'getContainerStyle',
    value: function getContainerStyle() {
      return (0, _lodash.merge)(this.getInitialStyle().container, this.props.containerStyle);
    }
  }, {
    key: 'getInitialStyle',
    value: function getInitialStyle(iconStyle) {
      var _props2 = this.props,
          direction = _props2.direction,
          position = _props2.position;
      return {
        fab: {
          height: _platform2["default"].fabWidth,
          width: _platform2["default"].fabWidth,
          borderRadius: _platform2["default"].fabBorderRadius,
          elevation: _platform2["default"].fabElevation,
          shadowColor: _platform2["default"].fabShadowColor,
          shadowOffset: {
            width: _platform2["default"].fabShadowOffsetWidth,
            height: _platform2["default"].fabShadowOffsetHeight
          },
          shadowOpacity: _platform2["default"].fabShadowOpacity,
          justifyContent: 'center',
          alignItems: 'center',
          shadowRadius: _platform2["default"].fabShadowRadius,
          position: 'absolute',
          bottom: _platform2["default"].fabBottom,
          backgroundColor: _platform2["default"].fabBackgroundColor
        },
        container: {
          position: 'absolute',
          top: position ? this.fabTopValue(position).top : undefined,
          bottom: position ? this.fabTopValue(position).bottom : _platform2["default"].fabContainerBottom,
          right: position ? this.fabTopValue(position).right : _platform2["default"].fabContainerBottom,
          left: position ? this.fabTopValue(position).left : undefined,
          width: _platform2["default"].fabWidth,
          height: this.containerHeight,
          flexDirection: direction ? direction === DIRECTION.LEFT || direction === DIRECTION.RIGHT ? 'row' : 'column' : 'column',
          alignItems: 'center'
        },
        iconStyle: _extends({
          color: _platform2["default"].fabIconColor,
          fontSize: _platform2["default"].fabIconSize,
          lineHeight: _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? 27 : undefined
        }, iconStyle),
        buttonStyle: {
          position: 'absolute',
          height: _platform2["default"].fabButtonHeight,
          width: _platform2["default"].fabButtonHeight,
          left: _platform2["default"].fabButtonLeft,
          borderRadius: _platform2["default"].fabButtonBorderRadius,
          transform: this.state.active ? [{
            scale: new _reactNative.Animated.Value(1)
          }] : [{
            scale: this.buttonScale
          }],
          marginBottom: _platform2["default"].fabButtonMarginBottom,
          backgroundColor: _platform2["default"].fabBackgroundColor
        }
      };
    }
  }, {
    key: 'fabOtherBtns',
    value: function fabOtherBtns(direction, i) {
      var active = this.props.active;

      if (direction === DIRECTION.UP) {
        return {
          top: undefined,
          bottom: active === false ? _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? 50 : 5 : i * 50 + 65,
          left: 8,
          right: 0
        };
      } else if (direction === DIRECTION.LEFT) {
        return {
          top: 8,
          bottom: 0,
          left: active === false ? _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? 8 : 8 : -(i * 50 + _platform2["default"].fabWidth + 2),
          right: 0
        };
      } else if (direction === DIRECTION.DOWN) {
        return {
          top: active === false ? _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? 50 : 8 : i * 50 + 73,
          bottom: 0,
          left: 8,
          right: 0
        };
      } else if (direction === DIRECTION.RIGHT) {
        return {
          top: 8,
          bottom: 0,
          left: active === false ? _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? 50 : 8 : i * 50 + 73,
          right: 0
        };
      }

      return null;
    }
  }, {
    key: 'prepareFabProps',
    value: function prepareFabProps() {
      var defaultProps = {
        style: this.getInitialStyle().fab
      };
      var incomingProps = (0, _lodash.clone)(this.props);
      delete incomingProps.onPress;
      return (0, _computeProps2["default"])(incomingProps, defaultProps);
    }
  }, {
    key: 'upAnimate',
    value: function upAnimate() {
      if (!this.props.active) {
        _reactNative.Animated.spring(this.containerHeight, {
          toValue: this.state.buttons * 51.3 + _platform2["default"].fabWidth
        }).start();

        _reactNative.Animated.spring(this.buttonScale, {
          toValue: 1,
          useNativeDriver: true
        }).start();
      } else {
        this.setState({
          active: false
        });

        _reactNative.Animated.spring(this.containerHeight, {
          toValue: _platform2["default"].fabWidth
        }).start();

        _reactNative.Animated.spring(this.buttonScale, {
          toValue: 0,
          useNativeDriver: true
        }).start();
      }
    }
  }, {
    key: 'leftAnimate',
    value: function leftAnimate() {
      if (!this.props.active) {
        _reactNative.Animated.spring(this.containerWidth, {
          toValue: this.state.buttons * 51.3 + _platform2["default"].fabWidth
        }).start();

        _reactNative.Animated.spring(this.buttonScale, {
          toValue: 1,
          useNativeDriver: true
        }).start();
      } else {
        this.setState({
          active: false
        });

        _reactNative.Animated.spring(this.containerHeight, {
          toValue: _platform2["default"].fabWidth
        }).start();

        _reactNative.Animated.spring(this.buttonScale, {
          toValue: 0,
          useNativeDriver: true
        }).start();
      }
    }
  }, {
    key: 'rightAnimate',
    value: function rightAnimate() {
      if (!this.props.active) {
        _reactNative.Animated.spring(this.containerWidth, {
          toValue: this.state.buttons * 51.3 + _platform2["default"].fabWidth
        }).start();

        _reactNative.Animated.spring(this.buttonScale, {
          toValue: 1,
          useNativeDriver: true
        }).start();
      } else {
        this.setState({
          active: false
        });

        _reactNative.Animated.spring(this.containerHeight, {
          toValue: _platform2["default"].fabWidth
        }).start();

        _reactNative.Animated.spring(this.buttonScale, {
          toValue: 0,
          useNativeDriver: true
        }).start();
      }
    }
  }, {
    key: 'downAnimate',
    value: function downAnimate() {
      if (!this.props.active) {
        _reactNative.Animated.spring(this.containerHeight, {
          toValue: _platform2["default"].fabWidth
        }).start();

        _reactNative.Animated.spring(this.buttonScale, {
          toValue: 1,
          useNativeDriver: true
        }).start();
      } else {
        this.setState({
          active: false
        });

        _reactNative.Animated.spring(this.containerHeight, {
          toValue: _platform2["default"].fabWidth
        }).start();

        _reactNative.Animated.spring(this.buttonScale, {
          toValue: 0,
          useNativeDriver: true
        }).start();
      }
    }
  }, {
    key: '_animate',
    value: function _animate() {
      var _props3 = this.props,
          direction = _props3.direction,
          position = _props3.position;

      if (direction) {
        if (direction === DIRECTION.UP) {
          if (position === POSITION.TOP_LEFT || position === POSITION.TOP_RIGHT) {
            console.warn('Passing direction = up with position = topLeft/topRight is not suggested.');
          } else {
            this.upAnimate();
          }
        } else if (direction === DIRECTION.LEFT) {
          if (position === POSITION.TOP_LEFT || position === POSITION.BOTTOM_LEFT) {
            console.warn('Passing direction = left with position = topLeft/bottomLeft is not suggested.');
          } else {
            this.leftAnimate();
          }
        } else if (direction === DIRECTION.RIGHT) {
          if (position === POSITION.TOP_RIGHT || position === POSITION.BOTTOM_RIGHT) {
            console.warn('Passing direction = right with position = topRight/bottomRight is not suggested.');
          } else {
            this.rightAnimate();
          }
        } else if (direction === DIRECTION.DOWN) {
          if (position === POSITION.BOTTOM_LEFT || position === POSITION.BOTTOM_RIGHT) {
            console.warn('Passing direction = down with position = bottomLeft/bottomRight is not suggested.');
          } else {
            this.downAnimate();
          }
        }
      } else {
        this.upAnimate();
      }
    }
  }, {
    key: 'fabOnPress',
    value: function fabOnPress() {
      var _this3 = this;

      if (this.props.onPress) {
        this.props.onPress();

        this._animate();

        this.activeTimer = setTimeout(function () {
          _this3.setState({
            active: _this3.props.active
          });
        }, 100);
      }
    }
  }, {
    key: 'renderButtons',
    value: function renderButtons() {
      var _this4 = this;

      var childrenArray = _react2["default"].Children.toArray(this.props.children);

      var newChildren = [];
      childrenArray.slice(1).map(function (child, i) {
        return newChildren.push(_react2["default"].createElement(AnimatedFab, _extends({
          style: _this4.getOtherButtonStyle(child, i)
        }, _this4.prepareButtonProps(child, i), {
          fabButton: true,
          key: i,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 427
          }
        }), child.props.children));
      });
      return newChildren;
    }
  }, {
    key: 'renderFab',
    value: function renderFab() {
      var childrenArray = _react2["default"].Children.toArray(this.props.children);

      (0, _lodash.remove)(childrenArray, function (item) {
        if (item.type.displayName === 'Styled(Button)') {
          return true;
        }

        return null;
      });
      return _react2["default"].cloneElement(childrenArray[0], {
        style: this.getInitialStyle(childrenArray[0].props.style).iconStyle
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var style = this.props.style;
      return _react2["default"].createElement(_reactNative.Animated.View, {
        style: this.getContainerStyle(),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 456
        }
      }, this.renderButtons(), _reactNative.Platform.OS === _commonColor.PLATFORM.IOS || _platform2["default"].androidRipple === false || _reactNative.Platform.Version <= 21 ? _react2["default"].createElement(_reactNative.TouchableOpacity, _extends({
        onPress: function onPress() {
          return _this5.fabOnPress();
        }
      }, this.prepareFabProps(), {
        activeOpacity: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 461
        }
      }), this.renderFab()) : _react2["default"].createElement(_reactNative.TouchableNativeFeedback, _extends({
        onPress: function onPress() {
          return _this5.fabOnPress();
        },
        background: _reactNative.TouchableNativeFeedback.Ripple(_platform2["default"].androidRippleColor, false)
      }, this.prepareFabProps(), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 469
        }
      }), _react2["default"].createElement(_reactNative.View, {
        style: [this.getInitialStyle().fab, style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 478
        }
      }, this.renderFab())));
    }
  }]);

  return Fab;
}(_react.Component);

var StyledFab = (0, _nativeBaseShoutemTheme.connectStyle)('NativeBase.Fab', {}, _mapPropsToStyleNames2["default"])(Fab);
exports.Fab = StyledFab;